import React from 'react'

export const asyncComponent = (loadComponent, namedExport) => (
  class AsyncComponent extends React.Component {
    state = {
      Component: null,
    }

    componentDidMount() {
      loadComponent().then((componentModule) => {
        const module = componentModule.default || componentModule[namedExport]
        this.setState({ Component: module })
      })
    }

    render() {
      const { Component } = this.state
      return Component && <Component {...this.props} />
    }
  }
)
